/**
 * Created by comoon on 1/27/16.
 */

var React = require("react");

var moment = require("moment");

var _ = require("underscore");

var StartCityList = require("../conf/start-city");

var Calendar = require("../cutil/Calendar.jsx");

var Tip = require("../cutil/Tip.jsx");

var NumberRange = require("../cutil/NumberRange");

var HeadCount = require("../util/head-count");

var Dispatcher = require("../Dispatcher");

var {ActionConstants, EventConstants} = require("../Constants");

var ALikeStore = require("../store/ALikeStore");

var {object2class} = require("../util/clazz");

var HCCalculator = HeadCount.Calculator;

var TripGrade = require("../conf/trip-grade");

var {AHEAD_MIN_DATE,AHEAD_MAX_DATE} = require('../conf/booking-conf');

module.exports = React.createClass({

    displayName: "QuoteApplyForm",

    getInitialState(){

        var hcCalculator = new HeadCount.Calculator(true);

        var hasCar = this.props.hasCar;

        var formData = {
            grade: ALikeStore.get_gradeType(),
            startDate: moment().add(50, 'days').format("YYYY-MM-DD"),
            startCity: StartCityList.BEIJING.id,
            defaultStart: true
        };

        var previous = this.props.formData;

        if (previous) {


            formData = _.pick(previous, 'grade', 'startDate', 'startCity', 'inquiryKey');

            hcCalculator.update(HCCalculator.Type.adult, previous.adtCnt)
                .update(HCCalculator.Type.child, previous.chdCnt)
                .update(HCCalculator.Type.room, previous.roomCnt)
                .update(HCCalculator.Type.car, previous.carCnt);

        } else {

            hcCalculator.update(HCCalculator.Type.adult, 2).update(HCCalculator.Type.room, 1);

            if (hasCar) {

                hcCalculator.update(HCCalculator.Type.car, 1);
            }
        }

        return {
            hasCar,
            hcCalculator,
            formData
        }
    },
    componentWillReceiveProps(nextProps){
        if (nextProps.formData) {

            var previous = nextProps.formData;

            if (previous.inquiryKey !== this.state.formData.inquiryKey) {

                var formData = _.pick(previous, 'grade', 'startDate', 'startCity', 'inquiryKey');

                var hcCalculator = this.state.hcCalculator;

                hcCalculator.update(HCCalculator.Type.adult, previous.adtCnt)
                    .update(HCCalculator.Type.child, previous.chdCnt)
                    .update(HCCalculator.Type.room, previous.roomCnt)
                    .update(HCCalculator.Type.car, previous.carCnt);

                this.setState({formData, hcCalculator});
            }
        }
    },
    componentWillMount(){
        ALikeStore.on(EventConstants.AJAX_COMMIT_APPLY_COMPLETE, this.on_commitApplyComplete);
        ALikeStore.on(EventConstants.ACTION_SWITCH_GRADE_TYPE, this.on_switchGradeComplete);
        ALikeStore.on(EventConstants.AJAX_SEARCH_PORT_INFO_COMPLETE, this.on_searchPortInfoComplete);
    },
    componentWillUnmount(){
        ALikeStore.off(EventConstants.AJAX_COMMIT_APPLY_COMPLETE, this.on_commitApplyComplete);
        ALikeStore.off(EventConstants.ACTION_SWITCH_GRADE_TYPE, this.on_switchGradeComplete);
        ALikeStore.off(EventConstants.AJAX_SEARCH_PORT_INFO_COMPLETE, this.on_searchPortInfoComplete);
    },
    on_commitApplyComplete(){
        this.setState({committing: false});
    },
    on_switchGradeComplete(){
        var gradeType = ALikeStore.get_gradeType();
        var formData = this.state.formData;
        formData.grade = gradeType;
        this.setState({formData})
    },
    on_searchPortInfoComplete(){
        var portInfo = ALikeStore.get_portInfo();
        var formData = this.state.formData;
        formData.startCity = portInfo[0].poi;
        this.setState({formData})
    },
    handle_toggleTripGrade(gradeType){
        var formData = this.state.formData;
        formData.grade = gradeType;

        var tripInfo = ALikeStore.get_tripBasicInfo();
        var versionId = gradeType === TripGrade.Enjoy.code ? tripInfo.versionId : tripInfo.luxuryVersionId ;
        var data = {
            versionId: versionId,
            gradeType: gradeType
        };
        Dispatcher.dispatch({type: ActionConstants.SWITCH_GRADE_TYPE, data: data});
    },
    handle_selectDepartDate(options){
        var formData = this.state.formData;
        formData.startDate = options.string;
        formData.defaultStart = false;
        this.setState({formData});
    },
    handle_chooseStartCity(city){
        var formData = this.state.formData;
        formData.startCity = city.id;
        this.setState({formData});
        this.handle_hidePort();
    },
    handle_changeAdultCount(val){
        var calculator = this.state.hcCalculator;
        calculator.update(HCCalculator.Type.adult, val);
        this.setState({hcCalculator: calculator});
    },
    handle_changeChildCount(val) {
        var calculator = this.state.hcCalculator;
        calculator.update(HCCalculator.Type.child, val);
        this.setState({hcCalculator: calculator});
    },
    handle_changeRoomCount(val) {
        var calculator = this.state.hcCalculator;
        calculator.update(HCCalculator.Type.room, val);
        this.setState({hcCalculator: calculator});
    },
    handle_changeCarCount(val) {
        var calculator = this.state.hcCalculator;
        calculator.update(HCCalculator.Type.car, val);
        this.setState({hcCalculator: calculator});
    },
    handle_fieldChange(event){

        var formData = this.state.formData;

        var name = event.target.name;

        if (event.target.type === 'checkbox') {
            formData[name] = event.target.checked ? 1 : 0;
        } else {
            formData[name] = event.target.value;
        }
        this.setState({formData});
    },

    handle_commitApply(){

        var me = this
        ,   uid = (window.isUser && window.isUser.uid) ? window.isUser.uid : $(".alike-container").data("uid")
        ;
        var defaultStart = me.state.formData.defaultStart;
        if( defaultStart ){
            alert('请选择出发日期！');
            return;
        }

        if(!uid && window.mobileLoginDialog){
            window.mobileLoginDialog.popUp({
                regsource:'autoreg_act_86',
                loginHandle:function(data){
                    me._handle_commitApply();
                }
            });
        } else {
            me._handle_commitApply();
        }  
    },

    _handle_commitApply(){

        var params = _.extend({}, this.state.formData, this.state.hcCalculator.toShort());

        Dispatcher.dispatch({type: ActionConstants.COMMIT_APPLY, data: params});

        this.setState({committing: true});
    },
    _getStartCityList(){
        var formData = this.state.formData;
        var startCityList = _.first(StartCityList, 4) || [];
        var portInfo = ALikeStore.get_portInfo();
        var isNewCity = !_.findWhere(startCityList, {id: formData.startCity}) ? true : false;
        if(formData.startCity && isNewCity){
            var city = _.findWhere(portInfo,{poi: formData.startCity});
            var newCity = {
                id: city.poi,
                name: city.name
            }
            if(startCityList.length>4){
                startCityList = _.initial(startCityList);
            }else{
                startCityList.push(newCity);
            }
        }
        return startCityList;
    },
    render_tripCalendar(){
        var startDate = this.state.formData.startDate;
        var defaultStart = this.state.formData.defaultStart;
        return(
            <div className="panelCalendarWarp mobilecCale">
                <Calendar
                    selected={startDate}
                    defaultStart={defaultStart}
                    onSelect={this.handle_selectDepartDate}
                    min={moment().add(AHEAD_MIN_DATE, 'days')}
                    max={moment().add(AHEAD_MAX_DATE, 'days')}
                    showPanel={true}
                    titlePosition="top"
                    panelWrap="panelCalendarWarp"
                />
            </div>
        )
    },
    handle_showPort(){
        this.setState({isShowPort: true})
    },
    handle_hidePort(){
        this.setState({isShowPort: false})
    },
    /**
     * 渲染二级口岸
     * @returns {XML}
     */
    render_portInfo(){
        var portInfo = ALikeStore.get_portInfo();
        if(!portInfo){
            return
        }
        var self = this;
        var formData = this.state.formData;
        var checked = (formData.startCity === portInfo[0].poi);
        var defaultCity = {
            id: portInfo[0].poi,
            name: portInfo[0].name
        }
        var gradeClazz = object2class({
            'grade': true,
            'checkable': true,
            'pull-left': true,
            'checked': checked
        });
        var defaultItem = (
            <div>
                <div className="info">根据所在IP推荐出发口岸</div>
                <div className={gradeClazz} key={portInfo[0].poi}
                     onClick={()=>{self.handle_chooseStartCity(defaultCity)}}>
                    {checked ? (<i className="icon-m-indicator-checked"/>) : null}
                    <span>{portInfo[0].name}</span>
                </div>
            </div>
        );
        var item = _.map(portInfo,function(item,index){
            if(index ==0){
                return
            }
            var checked = (formData.startCity === item.poi);
            var cityClazz = object2class({
                'city': true,
                'checkable': true,
                'pull-left': true,
                'checked': checked
            });
            var city = {
                id: item.poi,
                name: item.name
            }
            return(
                <li key={index}>
                    <div className={cityClazz} key={item.poi}
                         onClick={()=>{self.handle_chooseStartCity(city)}}>
                        {checked ? (<i className="icon-m-indicator-checked"/>) : null}
                        <span>{item.name}</span>
                    </div>
                </li>
            )
        })
        return(
            <div className="c-tip-content quote-hint-box city-list-wrap">
                <div className="c-head" onClick={this.handle_hidePort}>
                    <i className="icon-indicator-arrow-left"></i> 更多出发口岸
                </div>
                <div className="c-body">
                    <div className="city-list-box default-city">
                        {defaultItem}
                    </div>
                    <div className="info">
                        热门出发口岸
                    </div>
                    <ul className="city-list-box">
                        {item}
                    </ul>
                </div>

                <div className="c-footer">
                    <p className="info f-s">
                        *其他出发口岸城市请拨打<strong>4006-86-5060</strong>。支持全国出发。
                    </p>
                </div>

            </div>
        )
    },
    render(){
        var self = this;
        var state = this.state;
        var formData = state.formData || 0;
        var calculator = state.hcCalculator;
        var expired = this.props.expired;
        var isShowPort = state.isShowPort;
        var formClazz = object2class({
            'quote-apply-form': true,
            committing: state.committing
        });
        var startCityList = this._getStartCityList();

        return (
            <div className={formClazz}>
                <ul className="field-set">
                    {state.committing ? (<div className="cover"></div>) : null}
                    <li className="field grade-field checkable-field">
                        <label className="field-label">旅行品类</label>
                        {_.map(TripGrade.list, (grade)=> {
                            var checked = (+formData.grade === grade.code);
                            var gradeClazz = object2class({
                                'grade': true,
                                'checkable': true,
                                'pull-left': true,
                                'checked': checked
                            });
                            return (
                                <div className={gradeClazz} key={grade.code}
                                     onClick={e=> this.handle_toggleTripGrade(grade.code)}>
                                    {checked ? (<i className="icon-m-indicator-checked"/>) : null}
                                    <span>{grade.name}</span>
                                </div>
                            );
                        })}
                        <div className="clearfix"></div>
                    </li>
                    <li className="field date-field">
                        <label className="field-label">选择出发日期</label>
                        {this.render_tripCalendar()}
                    </li>
                    <li className="field port-field checkable-field">
                        <label className="field-label">出发城市</label>
                        <div className="city-box">
                        {
                            _.map(startCityList, function (city) {

                                var checked = (+formData.startCity === city.id);
                                var cityClazz = object2class({
                                    'city': true,
                                    'checkable': true,
                                    'pull-left': true,
                                    'checked': checked
                                });
                                var cityName = city.name.replace("市","");

                                return (
                                    <div className={cityClazz} key={city.id}
                                         onClick={()=>{self.handle_chooseStartCity(city)}}>
                                        {checked ? (<i className="icon-m-indicator-checked"/>) : null}
                                        <span>{cityName}</span>
                                    </div>
                                );
                            })
                        }
                        </div>
                        <div className="more-city" onClick={this.handle_showPort}>更多出发口岸<i className="icon-m-indicator-more"></i></div>
                        {
                            isShowPort ?(
                                self.render_portInfo()
                            ):null
                        }
                        <div className="clearfix"></div>
                    </li>
                    <li className={"field head-count-field" + (state.hasCar ? ' has-car': '')}>
                        <label className="field-label">出行人数</label>
                        <ul className="head-count-items">
                            <li className="head-count-item">
                                <span className="hc-title">成人</span>
                                <NumberRange min={calculator.adult.min} max={calculator.adult.max}
                                             className="number-input"
                                             current={calculator.adult.current}
                                             onChange={this.handle_changeAdultCount}
                                />
                                <span className="explanation">接受服务时年龄超过12岁(含)</span>
                            </li>
                            <li className="head-count-item">
                                <span className="hc-title">儿童</span>
                                <NumberRange min={calculator.child.min} max={calculator.child.max}
                                             className="number-input"
                                             current={calculator.child.current}
                                             onChange={this.handle_changeChildCount}
                                />
                                <span className="explanation">接受服务时年龄为2～12岁(不含)</span>
                            </li>
                            <li className="head-count-item">
                                <span className="hc-title">房间数</span>
                                <NumberRange min={calculator.room.min} max={calculator.room.max}
                                             className="number-input"
                                             current={calculator.room.current}
                                             onChange={this.handle_changeRoomCount}
                                />
                            </li>
                            {
                                state.hasCar ? (
                                    <li className="head-count-item">
                                        <span className="hc-title">车辆数</span>
                                        <span>
                                            <NumberRange min={calculator.car.min} max={calculator.car.max}
                                                         className="number-input"
                                                         current={calculator.car.current}
                                                         onChange={this.handle_changeCarCount}
                                            />
                                        </span>
                                    </li>
                                ) : null
                            }
                        </ul>
                    </li>
                </ul>
                <div className="op-feed">
                    <div className="error-msg">{ALikeStore.get_errorMsg(ActionConstants.COMMIT_APPLY)}</div>
                    <button className={`commit ${state.committing ? 'ing':''}`}
                            onClick={state.committing ? null : this.handle_commitApply}>
                        {state.committing ? '提交中…' : expired ? '重新计价' : '实时计价'}
                    </button>
                    <div className="explain">
                        {expired ?
                            (<span>因为机票的价格会有波动，为了保证客户不受损失，报价有严格有效时间。</span>) :
                            (
                                <span>确认以上信息点击提交计价，系统将自动计算包括该日期及前后2天的总价格</span>
                            )}
                    </div>
                </div>
            </div>
        );
    }
});
 



/** WEBPACK FOOTER **
 ** ./script/detail-m/QuoteApplyForm.jsx
 **/